import * as React from "react";

interface closeIconProps extends React.SVGProps<SVGSVGElement> {
  iconcolor?: string;
}
function SvgClose(props: closeIconProps) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 12 12" fill="none" {...props}>
      <path
        d="M6 7l5 5 1-1-5-5 5-5-1-1-5 5-5-5-1 1 5 5-5 5 1 1 5-5z"
        fill={props.iconcolor ?? "#B42626"}
      />
    </svg>
  );
}

export default SvgClose;
